function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var BaseBackoff =
/** @class */
function () {
  function BaseBackoff(duration) {
    this.duration = duration;
    this.attempt = 0;
  } // eslint-disable-next-line @typescript-eslint/no-unused-vars


  BaseBackoff.prototype.next = function (context) {
    throw new Error('Method not implemented.');
  };

  return BaseBackoff;
}();

/**
 * 一个常量退避策略，支持配置最大的退避次数
 * PS: 每次退避的时间都是常量值
 */

var ConstantBackoff =
/** @class */
function (_super) {
  __extends(ConstantBackoff, _super);
  /**
   * @param interval 每次退避时间的常量值
   * @param limit 最大退避次数
   */


  function ConstantBackoff(interval, limit) {
    var _this = _super.call(this, interval) || this;

    _this.limit = limit;
    return _this;
  }

  ConstantBackoff.prototype.next = function () {
    if (this.limit === undefined) {
      return this;
    }

    if (this.attempt >= this.limit) {
      return undefined;
    }

    this.attempt += 1;
    return this;
  };

  return ConstantBackoff;
}(BaseBackoff);
new ConstantBackoff(0, 0);

// 不对任何异常进行尝试
var dontHandleErrorFilter = function dontHandleErrorFilter() {
  return false;
}; // 不对任何相应结果进行重试

var dontHandleResultFilter = function dontHandleResultFilter() {
  return false;
};

var ExecuteWrapper =
/** @class */
function () {
  function ExecuteWrapper(errorFilter, resultFilter) {
    if (errorFilter === void 0) {
      errorFilter = dontHandleErrorFilter;
    }

    if (resultFilter === void 0) {
      resultFilter = dontHandleResultFilter;
    }

    this.errorFilter = errorFilter;
    this.resultFilter = resultFilter;
  }

  ExecuteWrapper.prototype.invoke = function (fn, context) {
    return __awaiter(this, void 0, void 0, function () {
      var value, rawError_1, error, handled;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , fn(context)];

          case 1:
            value = _a.sent();

            if (!this.resultFilter(value)) {
              return [2
              /*return*/
              , {
                success: value
              }];
            }

            return [2
            /*return*/
            , {
              value: value
            }];

          case 2:
            rawError_1 = _a.sent();
            error = rawError_1;
            handled = this.errorFilter(error);

            if (!handled) {
              throw error;
            }

            return [2
            /*return*/
            , {
              error: error
            }];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return ExecuteWrapper;
}();

var delay = function delay(duration) {
  var timeout = Math.max(duration, 0);

  if (timeout === 0) {
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    return setTimeout(resolve, timeout);
  });
};

var RetryPolicy =
/** @class */
function () {
  function RetryPolicy(options) {
    var _a;

    this.options = options;
    this.executor = new ExecuteWrapper(options.errorFilter, options.resultFilter);
    this.backoffFactory = (_a = options.backoffFactory) !== null && _a !== void 0 ? _a : new ConstantBackoff(0, options.maxRetry);
  }

  RetryPolicy.prototype.execute = function (fn) {
    return __awaiter(this, void 0, void 0, function () {
      var retries, retryContext, result, backoffContext, backoff;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            retries = 0;
            _a.label = 1;

          case 1:
            retryContext = {
              attempt: retries,
              startTimestamp: Date.now()
            };
            return [4
            /*yield*/
            , this.executor.invoke(fn, retryContext)];

          case 2:
            result = _a.sent();

            if ('success' in result) {
              // 1.请求执行成功，返回成功的响应数据
              return [2
              /*return*/
              , result.success];
            }

            if (!(retries < this.options.maxRetry)) return [3
            /*break*/
            , 5];
            backoffContext = {
              attempt: retries + 1,
              result: result
            };
            backoff = this.backoffFactory.next(backoffContext);
            if (!backoff) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , delay(backoff.duration)];

          case 3:
            _a.sent();

            _a.label = 4;

          case 4:
            // 2.1. 不需要退避，立即重试
            return [3
            /*break*/
            , 6];

          case 5:
            if ('error' in result) {
              throw result.error;
            }

            return [2
            /*return*/
            , result.value];

          case 6:
            retries++;
            return [3
            /*break*/
            , 1];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return RetryPolicy;
}();

var format = function format(duration) {
  return Math.max(duration !== null && duration !== void 0 ? duration : 0, 0);
};
/**
 * 指定退避时间的退避策略，配置的退避时间的个数即为最大退避次数
 * 例如：配置配置时间数组为 [10, 20, 30]，即表示最大退避 3 次，每次退避时间分别为 10, 20, 30 ms
 */


var IterableBackoff =
/** @class */
function (_super) {
  __extends(IterableBackoff, _super);
  /**
   * @param durations 退避时间数组，单位为 ms
   */


  function IterableBackoff(durations) {
    var _this = this;

    var _a;

    _this = _super.call(this, (_a = format(durations[0])) !== null && _a !== void 0 ? _a : 0) || this;
    _this.durations = durations;
    return _this;
  }

  IterableBackoff.prototype.next = function () {
    if (this.attempt >= this.durations.length) {
      return undefined;
    }

    this.duration = format(this.durations[this.attempt]);
    this.attempt += 1;
    return this;
  };

  return IterableBackoff;
}(BaseBackoff);

var CustomBackoff =
/** @class */
function (_super) {
  __extends(CustomBackoff, _super);

  function CustomBackoff(generator) {
    var _this = this;

    var _a;

    _this = _super.call(this, (_a = generator({
      attempt: 0
    })) !== null && _a !== void 0 ? _a : 0) || this;
    _this.generator = generator;
    return _this;
  }

  CustomBackoff.prototype.next = function (context) {
    var duration = this.generator(context);

    if (!duration) {
      return undefined;
    }

    this.duration = duration;
    return this;
  };

  return CustomBackoff;
}(BaseBackoff);

/**
 * 常见的几类响应错误码类型
 */
var REQUEST_ERROR_CODE;

(function (REQUEST_ERROR_CODE) {
  /**
   * 请求终止，一般是请求被调用方手动取消
   */
  REQUEST_ERROR_CODE["aborted"] = "ECONNABORTED";
  /**
   * 网络不可用状态（断网）
   */

  REQUEST_ERROR_CODE["network"] = "ERR_NETWORK";
  /**
   * 网络请求超时
   */

  REQUEST_ERROR_CODE["timeout"] = "ETIMEDOUT";
  /**
   * 请求错误，例如支持的协议类型、响应 4xx 的错误码
   */

  REQUEST_ERROR_CODE["badRequest"] = "ERR_BAD_REQUEST";
  /**
   * 响应错误，例如响应 5xx 的错误码
   */

  REQUEST_ERROR_CODE["badResponse"] = "ERR_BAD_RESPONSE";
})(REQUEST_ERROR_CODE || (REQUEST_ERROR_CODE = {}));

/**
 * 响应状态码，尽量对齐http状态码
 */
var RESPONSE_STATUS;

(function (RESPONSE_STATUS) {
  RESPONSE_STATUS[RESPONSE_STATUS["unknown"] = -1] = "unknown";
  RESPONSE_STATUS[RESPONSE_STATUS["success"] = 200] = "success";
})(RESPONSE_STATUS || (RESPONSE_STATUS = {}));

var RESPONSE_STATUS_TEXT_SUCCESS = 'Success';
function success(data) {
  return {
    data: data,
    status: RESPONSE_STATUS.success,
    statusText: RESPONSE_STATUS_TEXT_SUCCESS
  };
}
function fail(statusText) {
  return {
    data: [],
    status: RESPONSE_STATUS.unknown,
    statusText: statusText
  };
}

/**
 * 拦截器职责链的抽象基类，负责公共的拦截器维护和拦截器链执行逻辑
 * @param T 请求参数的类型
 * @param V 响应参数的类型
 */

var AbstractInterceptorChain =
/** @class */
function () {
  function AbstractInterceptorChain() {
    this.interceptors = [];
  }

  AbstractInterceptorChain.prototype.add = function (interceptor) {
    this.interceptors.push(interceptor);
  };

  AbstractInterceptorChain.prototype.proceed = function (config) {
    return __awaiter(this, void 0, void 0, function () {
      var chain;
      return __generator(this, function (_a) {
        chain = Array.from(this.interceptors);
        this.fillBuildInInterceptors(chain, config);
        return [2
        /*return*/
        , this.dispatch(config, chain, 0)];
      });
    });
  };
  /**
   * 拦截器链调度执行的逻辑
   * PS: 这里必须用传 index 索引下标方式执行是因为传给 interceptor 的 next 方法是可能会被多次调度的
   * @param config 请求的配置信息
   * @param chain 拦截器链
   * @param index 当前执行的拦截器索引下标
   * @returns 响应对象
   */


  AbstractInterceptorChain.prototype.dispatch = function (config, chain, index) {
    var _this = this;

    if (index >= chain.length) {
      var response = success([]);
      return Promise.resolve(response);
    }

    var interceptor = chain[index];

    var next = function next() {
      return _this.dispatch(config, chain, index + 1);
    };

    return interceptor.intercept(next, config);
  };

  return AbstractInterceptorChain;
}();

var _globalThis$1 = function (Object) {
  function get() {
    var _global = this || self;

    delete Object.prototype.__magic__;
    return _global;
  }

  if (typeof globalThis === "object") {
    return globalThis;
  }

  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);

/**
 * jaspi通道
 */
var JsApi =
/** @class */
function () {
  function JsApi() {
    var _a, _b;

    this.canUseNativeAndroid = ((_a = _globalThis$1.mqq) === null || _a === void 0 ? void 0 : _a.android) && ((_b = _globalThis$1._mqqWebViewJSInterface) === null || _b === void 0 ? void 0 : _b.invoke);
    this.currentSeqId = 0;
    this.reqCallbacks = new Map();
  }

  JsApi.prototype.JSApiCallback = function (response) {
    var reqCallback = this.reqCallbacks.get(response.callbackId);

    if (!reqCallback) {
      throw new Error("TypeError:[ark-request] the reqCallback of response[".concat(response.callbackId, "] can't found!"));
    }

    reqCallback.callback(response);
  };
  /**
     * 通过jsAPi和客户端通信
     * @param moduleName
     * @param method
     * @param requestData
     * @param callback
     */


  JsApi.prototype.invokeNative = function (moduleName, method, requestData, callback) {
    var _a;

    var requestConfig = requestData !== null && requestData !== void 0 ? requestData : {};
    var command = requestConfig.command;

    if (callback) {
      var callbackId = this.createReqSeq();
      this.reqCallbacks.set(callbackId, {
        callback: callback,
        command: command,
        startTime: Date.now()
      });
      requestConfig.callbackId = callbackId;
    }

    if (this.canUseNativeAndroid) {
      this.invokeNativeAndroid(moduleName, method, requestConfig);
    } else {
      (_a = _globalThis$1.mqq) === null || _a === void 0 ? void 0 : _a.invoke(moduleName, method, requestConfig);
    }
  };

  JsApi.prototype.invokeNativeAndroid = function (moduleName, method, requestData) {
    var _a;

    var url = "jsbridge://".concat(encodeURIComponent(moduleName), "/").concat(encodeURIComponent(method));

    if (requestData) {
      url += "?p=".concat(encodeURIComponent(JSON.stringify(requestData)));
    }

    (_a = _globalThis$1._mqqWebViewJSInterface) === null || _a === void 0 ? void 0 : _a.invoke(url);
  };

  JsApi.prototype.createReqSeq = function () {
    return this.currentSeqId += 1;
  };

  return JsApi;
}();

if (!_globalThis$1.jsApi) {
  _globalThis$1.jsApi = new JsApi();

  if (!_globalThis$1.JSApiCallback) {
    _globalThis$1.JSApiCallback = _globalThis$1.jsApi.JSApiCallback.bind(_globalThis$1.jsApi);
  }
} // eslint-disable-next-line import/no-mutable-exports


var JSApi = _globalThis$1.jsApi;

var JSAPIInvokeStrategy =
/** @class */
function () {
  function JSAPIInvokeStrategy() {}

  JSAPIInvokeStrategy.prototype.invoke = function (config) {
    return new Promise(function (resolve, reject) {
      if (!config.namespace) {
        throw new Error('jsapi, namespace is null.');
      }

      var params = config.params || {};
      var callback = config.callback ? function () {
        var res = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          res[_i] = arguments[_i];
        }

        resolve(success(res));
      } : undefined;

      try {
        JSApi.invokeNative(config.namespace, config.method, params, callback);

        if (!callback) {
          resolve(success([]));
        }
      } catch (error) {
        reject(fail('Error:[ark-request] Jsapi invokeNative fail.'));
      }
    });
  };

  return JSAPIInvokeStrategy;
}();

function isFunction$1(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
}

var _globalThis = function (Object) {
  function get() {
    var _global = this || self;

    delete Object.prototype.__magic__;
    return _global;
  }

  if (typeof globalThis === "object") {
    return globalThis;
  }

  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);

var MQQInvokeStrategy =
/** @class */
function () {
  function MQQInvokeStrategy() {}

  MQQInvokeStrategy.prototype.invoke = function (config) {
    return __awaiter(this, void 0, void 0, function () {
      var module, method;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!_globalThis.mqq) {
              throw new Error('UnknownError:[ark-request] mqq channel is undefined.');
            }

            if (!config.namespace) {
              throw new Error('TypeError:[ark-request] mqq invoke has no namespace!');
            }

            module = _globalThis.mqq[config.namespace];
            method = module === null || module === void 0 ? void 0 : module[config.method];
            if (!(method && isFunction$1(method))) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.innerModuleInvoke(method, config.params, config.callback)];

          case 1:
            // 1. 以mqq的内置模块形式调用
            // eg. mqq.ui.method(params, callback);
            return [2
            /*return*/
            , _a.sent()];

          case 2:
            return [4
            /*yield*/
            , this.innerCoreInvoke(_globalThis.mqq.invoke, config)];

          case 3:
            // 2. 以mqq的底层接口调用
            // eg. mqq.invoke(namespace, method, params, callback);
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };
  /**
   * mqq中内置模块的调用方式
   * 根据观察，大部分mqq的内置模块调用主要为以下四种形式:
   * mqq.ui.method();
   * mqq.ui.method(params);
   * mqq.ui.method(params, callback);
   * mqq.ui.method(callback);
   * @param func 待调用的模块方法
   * @param params 参数，可选参数
   * @param callback 回调方法，可选参数
   */


  MQQInvokeStrategy.prototype.innerModuleInvoke = function (func, params, callback) {
    return new Promise(function (resolve, reject) {
      var args = [];

      if (params) {
        args.push(params);
      }

      if (callback) {
        // 带callback的调用
        args.push(function () {
          var res = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            res[_i] = arguments[_i];
          }

          resolve(success(res));
        });
      }

      try {
        func.apply(void 0, __spreadArray([], __read(args), false));

        if (!callback) {
          resolve(success([]));
        }
      } catch (error) {
        reject(fail('Error:[ark-request] Mqq invoke module fail.'));
      }
    });
  };
  /**
   * mqq中core的invoke通用底层调用方式
   * @param config 请求信息
   */


  MQQInvokeStrategy.prototype.innerCoreInvoke = function (func, config) {
    return new Promise(function (resolve, reject) {
      try {
        func(config.namespace, config.method, config.params, function () {
          var res = [];

          for (var _i = 0; _i < arguments.length; _i++) {
            res[_i] = arguments[_i];
          }

          resolve(success(res));
        });
      } catch (error) {
        reject(fail("Error:[ark-request] Mqq invoke core[".concat(config.namespace, ".").concat(config.method, "] fail.")));
      }
    });
  };

  return MQQInvokeStrategy;
}();

var _a;
var INVOKE_CHANNEL;

(function (INVOKE_CHANNEL) {
  INVOKE_CHANNEL["mqq"] = "mqq";
  INVOKE_CHANNEL["jsapi"] = "jsapi";
})(INVOKE_CHANNEL || (INVOKE_CHANNEL = {}));

var DEFAULT_CONFIG$1 = {
  /**
   * 默认的客户端通信通道为mqq
   */
  schema: 'mqq',

  /**
   * 配置支持的客户端通道
   */
  channels: (_a = {}, _a[INVOKE_CHANNEL.mqq] = MQQInvokeStrategy, _a[INVOKE_CHANNEL.jsapi] = JSAPIInvokeStrategy, _a)
};

/**
 * 具体的调用客户端通道的拦截器
 * 通过配置的不同客户端通道的具体策略触发调用执行
 */

var CallNativeInterceptor =
/** @class */
function () {
  function CallNativeInterceptor() {}

  CallNativeInterceptor.prototype.intercept = function (next, config) {
    return __awaiter(this, void 0, void 0, function () {
      var StrategyClasses;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!config.schema) {
              throw Error("TypeError[ark-request]: the schema of request(".concat(config.namespace, ".").concat(config.method, ") is undefined."));
            }

            StrategyClasses = DEFAULT_CONFIG$1.channels[config.schema];

            if (!StrategyClasses) {
              throw Error("TypeError[ark-request]: can't match strategy to handle request(".concat(config.schema, ".").concat(config.namespace, ".").concat(config.method, ")."));
            }

            return [4
            /*yield*/
            , new StrategyClasses().invoke(config)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return CallNativeInterceptor;
}();

/**
 * 客户端通道的拦截器职责链子类
 * 职责链次序为 start -> [自定义拦截器] -> [网络请求] - end;
 */

var NativeInterceptorChain =
/** @class */
function (_super) {
  __extends(NativeInterceptorChain, _super);

  function NativeInterceptorChain() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NativeInterceptorChain.prototype.fillBuildInInterceptors = function (chain) {
    chain.push(new CallNativeInterceptor());
    return chain;
  };

  return NativeInterceptorChain;
}(AbstractInterceptorChain);

var NativeRequest =
/** @class */
function () {
  function NativeRequest(interceptors) {
    this.interceptors = interceptors;
  }

  NativeRequest.prototype.invoke = function (config) {
    this.interceptors.proceed(_assign({
      schema: DEFAULT_CONFIG$1.schema
    }, config)).then(function (response) {
      var _a, _b;

      var data = response.data;
      (_a = config.callback) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([config], __read(data), false));

      if (config.removeCallback && ((_b = config.params) === null || _b === void 0 ? void 0 : _b.callbackId)) {
        // window上的jsapi可能被提前赋值，给jsapi类新增方法不生效
        JSApi.reqCallbacks.delete(config.params.callbackId);
      }
    });
  };

  NativeRequest.prototype.register = function (name, handler) {
    if (!isFunction$1(handler)) {
      throw new Error("TypeError:[ark-request] The handler[".concat(name, "] to register is not function."));
    }

    var channel = this.getNativeChannel();
    var funcName = this.generateCallbackName(name);
    channel[funcName] = handler;
  };

  NativeRequest.prototype.unregister = function (name) {
    var channel = this.getNativeChannel();
    var callback = this.generateCallbackName(name);
    channel[callback] = undefined;
  };

  NativeRequest.prototype.notify = function (name) {
    var args = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }

    var channel = this.getNativeChannel();
    var callback = this.generateCallbackName(name);
    var handler = channel[callback];

    if (!isFunction$1(handler)) {
      throw new Error("TypeError:[ark-request] The handler[".concat(name, "] is not function!"));
    }

    handler.apply(void 0, __spreadArray([], __read(args), false));
  };

  NativeRequest.prototype.generateCallbackName = function (name) {
    // 这里暂时兼容现网写法，后续和客户端协商后这里名字建议加统一前缀
    return name;
  };

  NativeRequest.prototype.getNativeChannel = function () {
    // 这里暂时兼容现网写法，后续和客户端协商后这里不直接挂载在window上，考虑挂载在内部或window的子属性上
    return window;
  };

  return NativeRequest;
}();

function createNativeRequestInstance() {
  var interceptorChain = new NativeInterceptorChain();
  return new NativeRequest(interceptorChain);
}

var nativeRequest = createNativeRequestInstance();

var DEFAULT_CONFIG = {
  /**
   * 默认支持最多三次重试
   */
  maxRetry: 3
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    return fn.apply(thisArg, args);
  };
};

var toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */

function isArray(val) {
  return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */


function isUndefined(val) {
  return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */


function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */


function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */


function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */


function isArrayBufferView(val) {
  var result;

  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }

  return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */


function isString(val) {
  return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */


function isNumber(val) {
  return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */


function isObject(val) {
  return val !== null && _typeof(val) === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */


function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */


function isDate(val) {
  return toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */


function isFile(val) {
  return toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */


function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */


function isFunction(val) {
  return toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */


function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */


function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */


function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */


function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */


function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  } // Force an array if not already something iterable


  if (_typeof(obj) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */


function
  /* obj1, obj2, obj3, ... */
merge() {
  var result = {};

  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }

  return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */


function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */


function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }

  return content;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */


var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;

  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }

        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */


InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */


InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */


InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;

  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };

  return error;
};

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */


var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */


var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;

  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

var cookies = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */


var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }

  return requestedURL;
};

// c.f. https://nodejs.org/api/http.html#http_message_headers


var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */

var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }

      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

var isURLSameOrigin = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;
  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */

  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);
  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */

  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;

    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest(); // HTTP basic authentication

    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      } // Prepare the response


      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response); // Clean up request

      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        } // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request


        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        } // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'


        setTimeout(onloadend);
      };
    } // Handle browser request cancellation (as opposed to a manual cancellation)


    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Handle low level network errors


    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request)); // Clean up request

      request = null;
    }; // Handle timeout


    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional$1 = config.transitional || transitional;

      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }

      reject(createError(timeoutErrorMessage, config, transitional$1.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

      request = null;
    }; // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.


    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    } // Add headers to the request


    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    } // Add withCredentials to request if needed


    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    } // Add responseType to request if needed


    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    } // Handle progress if needed


    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    } // Not all browsers support upload events


    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function onCanceled(cancel) {
        if (!request) {
          return;
        }

        reject(!cancel || cancel && cancel.type ? new Cancel_1('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);

      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    } // Send the request


    request.send(requestData);
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;

  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }

  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {
  transitional: transitional,
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }

    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }

    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    if (utils.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],
  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }

          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */


var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/

  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });
  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */


function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel_1('canceled');
  }
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */


var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config); // Ensure headers exist

  config.headers = config.headers || {}; // Transform request data

  config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults_1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config); // Transform response data

    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config); // Transform response data

      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */


var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }

    return source;
  } // eslint-disable-next-line consistent-return


  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  } // eslint-disable-next-line consistent-return


  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };
  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};

var data = {
  "version": "0.26.1"
};

var VERSION = data.version;
var validators$1 = {}; // eslint-disable-next-line func-names

['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators$1[type] = function validator(thing) {
    return _typeof(thing) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});
var deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */

validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  } // eslint-disable-next-line func-names


  return function (value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */


function assertOptions(options, schema, allowUnknown) {
  if (_typeof(options) !== 'object') {
    throw new TypeError('options must be an object');
  }

  var keys = Object.keys(options);
  var i = keys.length;

  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];

    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);

      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }

      continue;
    }

    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  assertOptions: assertOptions,
  validators: validators$1
};

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */

function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */


Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config); // Set config.method

  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  } // filter out skipped interceptors


  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);

    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;

  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();

    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
}; // Provide aliases for supported request methods


utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
var Axios_1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */


function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this; // eslint-disable-next-line func-names

  this.promise.then(function (cancel) {
    if (!token._listeners) return;
    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }

    token._listeners = null;
  }); // eslint-disable-next-line func-names

  this.promise.then = function (onfulfilled) {
    var _resolve; // eslint-disable-next-line func-names


    var promise = new Promise(function (resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */


CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
/**
 * Subscribe to the cancel signal
 */


CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
/**
 * Unsubscribe from the cancel signal
 */


CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }

  var index = this._listeners.indexOf(listener);

  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */


CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */


var isAxiosError = function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */


function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context); // Copy axios.prototype to instance

  utils.extend(instance, Axios_1.prototype, context); // Copy context to instance

  utils.extend(instance, context); // Factory for creating new instances

  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
} // Create the default instance to be exported


var axios$1 = createInstance(defaults_1); // Expose Axios class to allow class inheritance

axios$1.Axios = Axios_1; // Expose Cancel & CancelToken

axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;
axios$1.VERSION = data.version; // Expose all/spread

axios$1.all = function all(promises) {
  return Promise.all(promises);
};

axios$1.spread = spread; // Expose isAxiosError

axios$1.isAxiosError = isAxiosError;
var axios_1 = axios$1; // Allow use of default import syntax in TypeScript

var _default = axios$1;
axios_1.default = _default;

var axios = axios_1;

/**
 * 具体的网络请求逻辑
 * 目前采用的策略是直接调用axios库的request接口执行
 */

var CallNetworkInterceptor =
/** @class */
function () {
  function CallNetworkInterceptor() {}

  CallNetworkInterceptor.prototype.intercept = function (next, config) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , axios.request(config)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  return CallNetworkInterceptor;
}();

var defaultTimeoutErrorFilter = function defaultTimeoutErrorFilter(error) {
  var _a;

  return (_a = error.message) === null || _a === void 0 ? void 0 : _a.includes('timeout');
};
/**
 * 负责重试处理逻辑的拦截器
 */


var RetryInterceptor =
/** @class */
function () {
  function RetryInterceptor() {}

  RetryInterceptor.prototype.intercept = function (next, config) {
    return __awaiter(this, void 0, void 0, function () {
      var retryPolicy;

      var _this = this;

      return __generator(this, function (_a) {
        // 不需要进行重试，直接执行后续请求并返回结果
        if (config.maxRetry <= 0) {
          return [2
          /*return*/
          , next()];
        }

        retryPolicy = new RetryPolicy(_assign({
          maxRetry: DEFAULT_CONFIG.maxRetry,
          errorFilter: defaultTimeoutErrorFilter
        }, config));
        return [2
        /*return*/
        , retryPolicy.execute(function (context) {
          return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  return [4
                  /*yield*/
                  , next()];

                case 1:
                  response = _a.sent();
                  response.retryContext = context;
                  return [2
                  /*return*/
                  , response];
              }
            });
          });
        })];
      });
    });
  };

  return RetryInterceptor;
}();

/**
 * 网络请求的拦截器职责链子类
 * 职责链次序为 start -> [自定义拦截器] -> [重试拦截器] -> [网络请求] -> end;
 */

var NetworkInterceptorChain =
/** @class */
function (_super) {
  __extends(NetworkInterceptorChain, _super);

  function NetworkInterceptorChain() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NetworkInterceptorChain.prototype.fillBuildInInterceptors = function (chain, config) {
    var _a;

    var maxRetry = (_a = config.maxRetry) !== null && _a !== void 0 ? _a : DEFAULT_CONFIG.maxRetry;

    if (maxRetry > 0) {
      chain.push(new RetryInterceptor());
    }

    chain.push(new CallNetworkInterceptor());
    return chain;
  };

  return NetworkInterceptorChain;
}(AbstractInterceptorChain);

var NetworkRequest =
/** @class */
function () {
  function NetworkRequest(defaults, interceptors) {
    this.defaults = defaults;
    this.interceptors = interceptors;
  }

  NetworkRequest.prototype.get = function (url, config) {
    return this.dispatchRequest('get', url, undefined, config);
  };

  NetworkRequest.prototype.post = function (url, data, config) {
    return this.dispatchRequest('post', url, data, config);
  };

  NetworkRequest.prototype.request = function (config) {
    return this.interceptors.proceed(_assign(_assign({}, this.defaults), config));
  };

  NetworkRequest.prototype.dispatchRequest = function (method, url, data, config) {
    var _a;

    var requestConfig = config !== null && config !== void 0 ? config : {};
    var headers = (_a = requestConfig.headers) !== null && _a !== void 0 ? _a : {};

    if (requestConfig.contentType) {
      headers['Content-Type'] = requestConfig.contentType;
    }

    return this.interceptors.proceed(_assign(_assign(_assign({}, this.defaults), requestConfig), {
      url: url,
      method: method,
      headers: headers,
      data: data !== null && data !== void 0 ? data : requestConfig.data
    }));
  };

  return NetworkRequest;
}();

function createNetworkRequestInstance(config) {
  var interceptorChain = new NetworkInterceptorChain();
  return new NetworkRequest(config || DEFAULT_CONFIG, interceptorChain);
}

var networkRequest = createNetworkRequestInstance();

export { BaseBackoff, ConstantBackoff, CustomBackoff, IterableBackoff, REQUEST_ERROR_CODE, RetryPolicy, createNativeRequestInstance, createNetworkRequestInstance, nativeRequest, networkRequest };
//# sourceMappingURL=index.js.map
